import axios from 'axios'

export const companiesMediaImage = {
  namespaced: true,
  state: {
    images: [],
    loading: false,
  },
  mutations: {
    prepareConnect(state) {
      state.loading = true
    },
    uploadMediaImagesSuccess(state, imageValues) {
      const newImages = imageValues.map(v => {
        return {
          id: v.data.data.id,
          name: v.name,
          url: v.data.data.url,
        }
      })
      state.images = state.images.concat(newImages)
      state.loading = false
    },
    deleteMediaImageSuccess(state, id) {
      state.images = state.images.filter(image => image.id !== id)
      state.loading = false
    },
    resetMediaImages(state) {
      state.images = []
    },
    apiFailure(state) {
      state.loading = false
    }
  },
  actions: {
    async uploadMediaImages({ commit, rootState }, images) {
      commit('prepareConnect')
      const imageValues = await Promise.all(images.map(image => {
        return new Promise((resolve) => {
          const reader = new FileReader()

          reader.readAsDataURL(image)

          reader.onload = async () => {
            const payload = {
              media_image: {
                content: reader.result,
                filename: image.name,
              }
            }
            await axios
              .post('/api/companies/' + rootState.route.params.company_uuid + '/media/images', payload)
              .then(res => {
                const resData = {
                  data: res.data,
                  name: image.name
                }
                resolve(resData)
              }).catch(err => {
                commit('apiFailure')
                commit('flash/updateFlash',{ type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
                console.error(err)
              })
          }
        })
      }))
      commit('uploadMediaImagesSuccess', imageValues)
    },
    deleteMediaImage({ commit, rootState }, id) {
      commit('prepareConnect')
      return axios
        .delete('/api/companies/' + rootState.route.params.company_uuid + '/media/images/' + id)
        .then(() => {
          commit('deleteMediaImageSuccess', id)
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash',{ type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
        })
    },
    resetMediaImages({ commit }) {
      commit('resetMediaImages')
    }
  }
}
